// extracted by mini-css-extract-plugin
export default {"tabContent":"HistoryContent_tabContent__1GBFX","emptyMessage":"HistoryContent_emptyMessage__2zwwi","loadMoreButton":"HistoryContent_loadMoreButton__d83Se"};